import {createAction} from 'redux-actions';
import {getMetadataCategoriesList} from '@pluto/rest';
import {QCJobsStatusesPayload} from '../../qc-jobs-statuses';

export const METADATA_CATEGORIES_SET = 'METADATA_CATEGORIES_SET';

export const setMetadataCategoriesAction = createAction<Promise <QCJobsStatusesPayload>>(METADATA_CATEGORIES_SET, async () => {
    return await getMetadataCategoriesList();
});
